// Entry da Home redesenhada. Roda APÓS o guard (que já fez ensureAuthenticated
// inline no home.html antes deste script). Monta o shell+grid no #home-root.
//
// O bridge `window.tripsApi` é setado pelo módulo features/home/tripsApi.js,
// também carregado pelo home.html. mountHome() espera por window.tripsApiReady
// internamente.

import './features/auth/logout.js';   // expõe window.logoutConfirm
import { mountHome } from './features/home/render.js';

const root = document.getElementById('home-root');
if (root) mountHome(root).catch((err) => {
  console.error('[home] mountHome failed:', err);
  root.innerHTML = `<div style="padding:48px;text-align:center;color:var(--text-secondary)">Falha ao carregar a Home. <a href="/login.html">Voltar pra login</a></div>`;
});
